import React,{useState,useEffect} from 'react'
import {Row,Col,Button,Card} from 'react-bootstrap'


import Loader from '../components/Loader'
import Message from '../components/Message'
//import PlayerVideo from '../components/PlayerVideo'
import Accordion from 'react-bootstrap/Accordion'

import {useDispatch , useSelector } from 'react-redux'
import {Link} from 'react-router-dom'
import { listVideos_action} from '../actions/videoActions'
import ResponsiveEmbed from 'react-responsive-embed'
import FormContainer from '../components/FormContainer'
import { $CombinedState } from 'redux'
import {AiFillPlayCircle,AiOutlinePlayCircle} from "react-icons/ai";

function VideoScreen({history}){

    const [message,setMessage] = useState('')
    const userLogin = useSelector(state=>state.userLogin)
    const {userInfo} = userLogin

    //從store得到的資料
    const listVideos = useSelector(state=>state.videoList)
    const {loading,error,videos} = listVideos

 

    const dispatch = useDispatch()

    useEffect(() => {
        if(!userInfo ){
            history.push('/login')
        }else{
  
          
          // !videos 因為 FAIL 後是沒有video的   
          // Object.keys(videos).length==0 是為了一開始的初始化
          if( !videos  || Object.keys(videos).length==0 ){
       
            //dispatch( {type:VIDEO_LIST_RESET})
            dispatch( listVideos_action('level') )
            //console.log('if',videos,!videos.length)
            

          }else {
    
             if (!("return_null" in videos) ){
                const iframe = document.getElementById('iframe_video');
                iframe.src = videos[0]['child'][0]['url'];
                const video_des = document.getElementById('video_des');
                video_des.innerHTML = videos[0]['child'][0]['description'];
             }

           }



          }
        
    }, [history,dispatch,userInfo,videos])


    const click_listen = (e) =>{
        //console.log(e.target.className)
        const get_all = document.getElementsByClassName(e.target.className)
        for (var i=0; i<get_all.length ; i++){
            get_all[i].style.backgroundColor = ""
        }
        //--------------------------------------------
        //console.log(e.currentTarget)
        e.currentTarget.style.backgroundColor = "silver";
        const iframe = document.getElementById('iframe_video');
        iframe.src = e['target']['childNodes'][2]['textContent']
        const video_des = document.getElementById('video_des');
        video_des.innerHTML = e['target']['childNodes'][3]['textContent'];
  
    }



    return(
        <>
         {message && <Message variant='danger'>{message}</Message>}
         {error && <Message variant='danger'>{error}</Message> }
         {loading && <Loader/>}
         {("return_null" in videos) ? (
             <h1>你尚未取得任何權限</h1>
         ) : null}
         { (Object.keys(videos).length >0 && !("return_null" in videos) ) &&(
            <Row >
                <Col  sm={12} md={8} lg={9} xl={8} >
                
                    <ResponsiveEmbed  id="iframe_video" src='' allowFullScreen={true} webkitallowfullscreen="true" scrolling="no" />
                   
                    <Accordion defaultActiveKey="0" style={{paddingBottom:"30px",paddingLeft:"0px",paddingRight:"0px",dispaly:"none"}}>
                        <Card style={{border:"0px"}}>
                            <Card.Header style={{paddingLeft:"8px",paddingRight:"8px",paddingTop:"0px",paddingBottom:"0px",backgroundColor:"inherit",borderBottom:"0px"}}>
                            <Accordion.Toggle className="btn btn-outline-warning"  as={Button} variant="outline-warning" eventKey="0" style={{width:"100%",fontSize:"15px",textDecoration:"none"}}>
                                影片詳細介紹
                            </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="0">

                            <Card.Body style={{boxShadow:"0 4px 2px -2px #bebebe",borderBottom:"none"}} >
                                <h3 style={{color:"#55595c"}}>影片介紹:</h3>
                                <div id="video_des"></div>
                              
                            </Card.Body>

                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                  
                </Col>

                <Col sm={12} md={4} lg={3} xl={4} style={{paddingTop:"10px",paddingLeft:"20px",paddingRight:"20px"}}>
                    <Accordion>
                        {videos.map((video,i)=>{
                                return(  
                                   <> 
                                        <Card>
                                            <Card.Header style={{boxShadow:"0 4px 2px -2px #bebebe",borderBottom:"none"}}>
                                                <Accordion.Toggle as={Button} variant="link" eventKey={i+1} style={{width:"100%",fontSize:"24px",textDecoration:"none",color:"rgb(104 104 104)"}}>
                                                    {video.level_name} ▾  
                                                </Accordion.Toggle>
                                            </Card.Header>
                                        </Card>

                                        {video.child.map((video_child)=>{
                                            return(
                                                    <Accordion.Collapse eventKey={i+1}>
                                                        <Card.Body  onClick={click_listen} style={{boxShadow:"0 4px 2px -2px #bebebe",borderBottom:"none"}}>
                                                        <AiFillPlayCircle style={{width:"2em"}}/>  
                                                        {video_child.name}
                                                        <p style={{display:"none"}}>{video_child.url}</p>
                                                        <p style={{display:"none"}}>{video_child.description}</p>
                                                  
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                            )
                                        })}
                                    </>
                                )
                            })}
                    </Accordion>
                </Col>
            </Row>
         )}


           
        </>
        )
}

export default VideoScreen


